module.exports = __webpack_public_path__ + "static/img/home_cpjfw_zfjjfa.5c24019.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_cpjfw_zfjjfa.png
// module id = PqlN
// module chunks = 21